import React from "react";
import { DocumentDto } from "../../../../data/types";
import { Menu } from "./menu";

interface Props {
  document: DocumentDto;
}
export const ActionsCell: React.FC<Props> = ({ document }) => {
  return <Menu document={document} isMobile={false} />;
};
